import {
  ChallengeList,
  SocialsChallengesClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const socialsChallengesClient = new SocialsChallengesClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handleGetMyPendingChallenges = async ({
  page,
  limit,
  sort,
  inviteId,
  gameId,
}: {
  page?: number;
  limit?: number;
  sort?: string;
  inviteId?: string;
  gameId?: string;
}): Promise<ChallengeList> => {
  return (
    await socialsChallengesClient.getMyPendingChallenges(
      page,
      limit,
      sort,
      inviteId,
      gameId
    )
  ).data;
};
